import { API } from './api';
import { BASE_URL } from './env';
import mapboxgl from 'mapbox-gl';

export const getStates = async (country: string) => {
  return API.get(`${BASE_URL}/base/growers/states?country=${country}`).then((res) => {
    return res.data;
  });
};

export interface IReason {
  sfValue: string;
  value: string;
}

export enum ClassificationLayersStatus {
  UNAVAILABLE = 'UNAVAILABLE',
  LOADING = 'LOADING',
  GENERATING = 'GENERATING',
  PENDINDG = 'PENDINDG',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface LayerOption {
  label: string;
  value: string;
}

export interface TrainingClass {
  id: string;
  label: string;
  geometry: {
    type: string;
  };
  properties: {
    class: number;
  };
}
export const classificationColors = {
  tree: '#33a02c',
  barren: '#fdbf6f',
  grass: '#6dff00',
};

export interface LayersOverrite {
  fillPaint?: mapboxgl.FillPaint;
}

export const classificationStyling: LayersOverrite = {
  fillPaint: {
    'fill-color': [
      'match',
      ['get', 'class'], // read the 'class' property
      1,
      classificationColors.tree, // tree
      2,
      classificationColors.barren, // barren
      3,
      classificationColors.grass, // grass
      /* fallback */ '#000000',
    ],
    'fill-opacity': 0.5,
  },
};

export const CDLStyling: LayersOverrite = {
  fillPaint: {
    'fill-color': [
      'match',
      ['get', 'class'], // read the 'class' property
      0,
      '#000000',
      1,
      '#ffd400',
      2,
      '#ff2626',
      3,
      '#00a9e6',
      4,
      '#ff9e0f',
      5,
      '#267300',
      6,
      '#ffff00',
      7,
      '#70a800',
      8,
      '#00af4d',
      9,
      '#e0a60f',
      10,
      '#e0a60f',
      11,
      '#80d4ff',
      12,
      '#e2007f',
      13,
      '#8a6453',
      14,
      '#d9b56c',
      15,
      '#a87000',
      16,
      '#d69dbc',
      17,
      '#737300',
      18,
      '#ae017e',
      19,
      '#a15889',
      20,
      '#73004c',
      21,
      '#d69dbc',
      22,
      '#d1ff00',
      23,
      '#8099ff',
      24,
      '#d6d600',
      25,
      '#d1ff00',
      26,
      '#00af4d',
      27,
      '#ffa8e3',
      28,
      '#a5f58d',
      29,
      '#00af4d',
      30,
      '#d69dbc',
      31,
      '#a900e6',
      32,
      '#a80000',
      33,
      '#732600',
      34,
      '#00af4d',
      35,
      '#b380ff',
      36,
      '#732600',
      37,
      '#ff6666',
      38,
      '#ff6666',
      39,
      '#ffcc66',
      40,
      '#ff6666',
      41,
      '#00af4d',
      42,
      '#00deb0',
      43,
      '#55ff00',
      44,
      '#f5a27a',
      45,
      '#ff6666',
      46,
      '#00af4d',
      47,
      '#80d4ff',
      48,
      '#e8beff',
      49,
      '#b2ffde',
      50,
      '#00af4d',
      51,
      '#bfbf7a',
      52,
      '#95ce93',
      53,
      '#c7d79e',
      54,
      '#ccbfa3',
      55,
      '#ff00ff',
      56,
      '#ff91ab',
      57,
      '#b90050',
      58,
      '#704489',
      59,
      '#007878',
      60,
      '#b39c70',
      61,
      '#ffff80',
      62,
      '#b6705c',
      63,
      '#00a884',
      64,
      '#ebd6b0',
      65,
      '#b39c70',
      66,
      '#f7f7f7',
      67,
      '#9c9c9c',
      68,
      '#4d70a3',
      69,
      '#80b3b3',
      70,
      '#e9ffbe',
      71,
      '#00ffff',
      72,
      '#4d70a3',
      73,
      '#d4e3fc',
      74,
      '#9c9c9c',
      75,
      '#9c9c9c',
      76,
      '#9c9c9c',
      77,
      '#9c9c9c',
      78,
      '#ccbfa3',
      79,
      '#95ce93',
      80,
      '#95ce93',
      81,
      '#95ce93',
      82,
      '#c7d79e',
      83,
      '#e9ffbe',
      84,
      '#80b3b3',
      85,
      '#80b3b3',
      86,
      '#00ff8c',
      87,
      '#d69dbc',
      88,
      '#ff6666',
      89,
      '#ff6666',
      90,
      '#ff6666',
      91,
      '#ff6666',
      92,
      '#ff91ab',
      93,
      '#344a34',
      94,
      '#e67525',
      95,
      '#ff6666',
      96,
      '#ff6666',
      97,
      '#66994d',
      98,
      '#ff6666',
      99,
      '#b39c70',
      100,
      '#ff91ab',
      101,
      '#ff6666',
      102,
      '#ff91ab',
      103,
      '#ff6666',
      104,
      '#ff6666',
      105,
      '#ff91ab',
      106,
      '#00af4d',
      107,
      '#ffd400',
      108,
      '#ffd400',
      109,
      '#ff6666',
      110,
      '#ffd400',
      111,
      '#ff6666',
      112,
      '#8a6453',
      113,
      '#ff6666',
      114,
      '#ff2626',
      115,
      '#e2007f',
      116,
      '#ff9e0f',
      117,
      '#ff9e0f',
      118,
      '#a87000',
      119,
      '#ffd400',
      120,
      '#a87000',
      121,
      '#6f726f', // updated
      122,
      '#267300',
      123,
      '#ffd400',
      124,
      '#000099',
      125,
      '#ff6666',
      126,
      '#ff6666',
      127,
      '#ff6666',
      128,
      '#ff6666',
      129,
      '#ff6666',
      130,
      '#ff6666',
      131,
      '#ff6666',
      132,
      '#ff6666',
      133,
      '#267300',
      134,
      '#ffd400',
      135,
      '#000000',
      136,
      '#ffd400',
      137,
      '#ff2626',
      138,
      '#00a9e6',
      139,
      '#ff9e0f',
      140,
      '#000000',
      141,
      '#ffd400',
      142,
      '#ff2626',
      143,
      '#00a9e6',
      144,
      '#ff9e0f',
      145,
      '#267300',
      146,
      '#ffff00',
      147,
      '#70a800',
      148,
      '#00af4d',
      149,
      '#e0a60f',
      150,
      '#e0a60f',
      151,
      '#80d4ff',
      152,
      '#95d769', // update
      153,
      '#8a6453',
      154,
      '#d9b56c',
      155,
      '#a87000',
      156,
      '#d69dbc',
      157,
      '#737300',
      158,
      '#ae017e',
      159,
      '#a15889',
      160,
      '#73004c',
      161,
      '#d69dbc',
      162,
      '#d1ff00',
      163,
      '#8099ff',
      164,
      '#d6d600',
      165,
      '#d1ff00',
      166,
      '#00af4d',
      167,
      '#ffa8e3',
      168,
      '#a5f58d',
      169,
      '#00af4d',
      170,
      '#d69dbc',
      171,
      '#a900e6',
      172,
      '#a80000',
      173,
      '#732600',
      174,
      '#00af4d',
      175,
      '#b380ff',
      176,
      '#d7c269', //updated
      177,
      '#ff6666',
      178,
      '#ff6666',
      179,
      '#ffcc66',
      180,
      '#ff6666',
      181,
      '#00af4d',
      182,
      '#00deb0',
      183,
      '#55ff00',
      184,
      '#f5a27a',
      185,
      '#ff6666',
      186,
      '#00af4d',
      187,
      '#80d4ff',
      188,
      '#e8beff',
      189,
      '#b2ffde',
      190,
      '#00af4d',
      191,
      '#bfbf7a',
      192,
      '#95ce93',
      193,
      '#c7d79e',
      194,
      '#ccbfa3',
      195,
      '#25afc2',
      196,
      '#ff91ab',
      197,
      '#b90050',
      198,
      '#704489',
      199,
      '#007878',
      200,
      '#b39c70',
      201,
      '#ffff80',
      202,
      '#b6705c',
      203,
      '#00a884',
      204,
      '#ebd6b0',
      205,
      '#b39c70',
      206,
      '#f7f7f7',
      207,
      '#9c9c9c',
      208,
      '#4d70a3',
      209,
      '#80b3b3',
      210,
      '#e9ffbe',
      211,
      '#00ffff',
      212,
      '#4d70a3',
      213,
      '#d4e3fc',
      214,
      '#9c9c9c',
      215,
      '#9c9c9c',
      216,
      '#9c9c9c',
      217,
      '#9c9c9c',
      218,
      '#ccbfa3',
      219,
      '#95ce93',
      220,
      '#95ce93',
      221,
      '#95ce93',
      222,
      '#c7d79e',
      223,
      '#ff91ab',
      224,
      '#00af4d',
      225,
      '#ffd400',
      226,
      '#ffd400',
      227,
      '#ff6666',
      228,
      '#ffd400',
      229,
      '#ff6666',
      230,
      '#8a6453',
      231,
      '#ff6666',
      232,
      '#ff2626',
      233,
      '#e2007f',
      234,
      '#ff9e0f',
      235,
      '#ff9e0f',
      236,
      '#a87000',
      237,
      '#ffd400',
      238,
      '#a87000',
      239,
      '#267300',
      240,
      '#267300',
      241,
      '#ffd400',
      242,
      '#000099',
      243,
      '#ff6666',
      244,
      '#ff6666',
      245,
      '#ff6666',
      246,
      '#ff6666',
      247,
      '#ff6666',
      248,
      '#ff6666',
      249,
      '#ff6666',
      250,
      '#ff6666',
      254,
      '#267300',
      /* fallback */ '#000000',
    ],
    'fill-opacity': 1,
  },
};

export const DWStyling: LayersOverrite = {
  fillPaint: {
    'fill-color': [
      'match',
      ['get', 'class'], // read the 'class' property
      0,
      '#419BDF', // water (0)
      1,
      '#397D49', // trees (1)
      2,
      '#88B053', // grass (2)
      3,
      '#7A87C6', // flooded_vegetation (3)
      4,
      '#E49635', // crops (4)
      5,
      '#DFC35A', // shrub_and_scrub (5)
      6,
      '#C4281B', // built (6)
      7,
      '#A59B8F', // bare (7)
      8,
      '#B39FE1', // snow_and_ice (8)
      /* fallback */ '#000000',
    ],
    'fill-opacity': 0.5,
  },
};

export const ESAStyling: LayersOverrite = {
  fillPaint: {
    'fill-color': [
      'match',
      ['get', 'class'], // read the 'class' property
      10,
      '#006400', //– Tree cover
      20,
      '#ffbb22', //– Shrubland
      30,
      '#ffff4c', //– Grassland
      40,
      '#f096ff', //– Cropland
      50,
      '#fa0000', //– Built‑up
      60,
      '#b4b4b4', //– Bare / sparse vegetation
      70,
      '#f0f0f0', //– Snow and ice
      80,
      '#0064c8', //– Permanent water bodies
      90,
      '#0096a0', //– Herbaceous wetland
      95,
      '#00cf75', //– Mangroves
      100,
      '#fae6a0', //– Moss and lichen
      /* fallback */ '#000000',
    ],
    'fill-opacity': 0.5,
  },
};

export const leadDeletionReasons = {
  // generalReasons: [
  //   'Already working with competitor',
  //   'Conflict of interest',
  //   'Not interested in the program',
  //   'Unresponsive',
  //   'Not a real Lead',
  //   'Not interested in the program',
  //   'Unresponsive',
  //   'Not a real Lead',
  //   'Other',
  // ],
  brReasons: [
    {
      sfValue: 'Failed Eligibility - Range & Pastureland practices already adopted',
      value: 'Falha de Elegibilidade - Práticas de Pastejo já aplicadas',
    },
    {
      sfValue: 'Failed Eligibility - Interested in Specialty, Vegetable, Orchard, Forestry and Timber, or Other crop contract',
      value: 'Falha de Elegibilidade - Interesse em Especialidade, Vegetal, Pomar, Silvicultura e Madeira ou Outros contratos de Lavoura',
    },
    {
      sfValue: 'Failed Eligibility - Receiving conflicting conservation funding',
      value: 'Falha de Elegibilidade - Receiving conflicting conservation funding',
    },
    {
      sfValue: 'Failed Eligibility - Land ownership issues',
      value: 'Falha de Elegibilidade - Conflitos de Propriedade',
    },
    {
      sfValue: 'Failed Eligibility - Too few acres',
      value: 'Falha de Elegibilidade - Hectares abaixo do mínimo necessário',
    },
    {
      sfValue: 'Failed Eligibility - Carbon below minimum',
      value: 'Falha de Elegibilidade - Carbono abaixo do mínimo necessário',
    },
    {
      sfValue: 'Failed Eligibility - Already enrolled in competitive carbon program',
      value: 'Falha de Elegibilidade - Já registrado em um programa competitivo de carbono',
    },
    { sfValue: 'Not interested in the program', value: 'Sem interesse no programa' },
    { sfValue: 'Agoro Declined', value: 'Recusado pela Agoro' },
    { sfValue: 'Already working with competitor', value: 'Já trabalhando com concorrente' },
    { sfValue: 'Concerns with contract duration', value: 'Conflitos com relação a duração do contrato' },
    { sfValue: 'Concerns with payment amounts', value: 'Conflitos com relação a quantia a ser paga' },
    {
      sfValue: 'Concerns with payment structure or frequency',
      value: 'Conflitos com relação a estrutura ou frequência de pagamento',
    },
    { sfValue: 'Conflict of interest', value: 'Conflitos de interesse' },
    { sfValue: 'Unresponsive', value: 'Sem resposta' },
    { sfValue: 'Not a real Lead', value: 'Não é uma Lead real' },
    { sfValue: 'Other', value: 'Outros' },
  ],
  usaReasons: [
    {
      sfValue: 'Failed Eligibility - Row crop practices already adopted',
      value: 'Failed Eligibility - Row crop practices already adopted',
    },
    {
      sfValue: 'Failed Eligibility - Range & Pastureland practices already adopted',
      value: 'Failed Eligibility - Range & Pastureland practices already adopted',
    },
    {
      sfValue: 'Failed Eligibility - Interested in Specialty, Vegetable, Orchard, Forestry and Timber, or Other crop contract',
      value: 'Failed Eligibility - Interested in Specialty, Vegetable, Orchard, Forestry and Timber, or Other crop contract',
    },
    {
      sfValue: 'Failed Eligibility - Receiving conflicting conservation funding',
      value: 'Failed Eligibility - Receiving conflicting conservation funding',
    },
    { sfValue: 'Failed Eligibility - Land ownership issues', value: 'Failed Eligibility - Land ownership issues' },
    { sfValue: 'Failed Eligibility - Too few acres', value: 'Failed Eligibility - Too few acres' },
    { sfValue: 'Failed Eligibility - Carbon below minimum', value: 'Failed Eligibility - Carbon below minimum' },
    {
      sfValue: 'Failed Eligibility - Already enrolled in competitive carbon program',
      value: 'Failed Eligibility - Already enrolled in competitive carbon program',
    },
    { sfValue: 'Not interested in the program', value: 'Not interested in the program' },
    { sfValue: 'Agoro Declined', value: 'Agoro Declined' },
    { sfValue: 'Already working with competitor', value: 'Already working with competitor' },
    { sfValue: 'Concerns with contract duration', value: 'Concerns with contract duration' },
    { sfValue: 'Concerns with payment amounts', value: 'Concerns with payment amounts' },
    { sfValue: 'Concerns with payment structure or frequency', value: 'Concerns with payment structure or frequency' },
    { sfValue: 'Conflict of interest', value: 'Conflict of interest' },
    { sfValue: 'Unresponsive', value: 'Unresponsive' },
    { sfValue: 'Not a real Lead', value: 'Not a real Lead' },
    { sfValue: 'Other', value: 'Other' },
  ],
};
